import { useQuery } from "@tanstack/react-query";
import { getRiskSummary, getRisks } from "../api";
import { RiskCategory } from "../types";

export const useRiskSummary = () => {
    return useQuery({
        queryKey: ["visionStudio", "riskSummary"],
        queryFn: getRiskSummary,
    });
};

export const useRisks = (category?: RiskCategory) => {
    return useQuery({
        queryKey: ["visionStudio", "risks", category],
        queryFn: () => getRisks(category),
    });
};
